import Vue from 'vue'

Vue.prototype.$formatDate = date => {
  const dateObj = new Date(date)

  const day = new Intl.DateTimeFormat('en-AU', { weekday: 'short'}).format(dateObj)
  const dayDate = new Intl.DateTimeFormat('en-AU', { day: 'numeric'}).format(dateObj)
  const month = new Intl.DateTimeFormat('en-AU', { month: 'short'}).format(dateObj)

  return `${day} ${dayDate} ${month}`
}

Vue.prototype.$formatDateRange = (startDate, endDate) => {
  const startDateObj = new Date(startDate)
  const endDateObj = new Date(endDate)

  // same day => { day, date month }
  if (startDate === endDate) {
    const day = new Intl.DateTimeFormat('en-AU', { weekday: 'short' }).format(startDateObj)
    const dayDate = new Intl.DateTimeFormat('en-AU', { day: 'numeric' }).format(startDateObj)
    const month = new Intl.DateTimeFormat('en-AU', { month: 'short' }).format(startDateObj)

    return `${day} ${dayDate} ${month}`
  }

  // same month => { start dayDate - end dayDate, month}
  if (startDate.slice(5, 7) === endDate.slice(5, 7)) {
    const startDayDate = new Intl.DateTimeFormat('en-AU', { day: 'numeric' }).format(startDateObj)
    const startMonth = new Intl.DateTimeFormat('en-AU', { month: 'short' }).format(startDateObj)

    const endDayDate = new Intl.DateTimeFormat('en-AU', { day: 'numeric' }).format(endDateObj)
    const endMonth = new Intl.DateTimeFormat('en-AU', { month: 'short' }).format(endDateObj)

    return `${startDayDate} ${startMonth} - ${endDayDate} ${endMonth}`
  }

  //const startDay = new Intl.DateTimeFormat('en-AU', { weekday: 'short'}).format(startDateObj)
  const startDayDate = new Intl.DateTimeFormat('en-AU', { day: 'numeric' }).format(startDateObj)
  const startMonth = new Intl.DateTimeFormat('en-AU', { month: 'short' }).format(startDateObj)

  // const endDay = new Intl.DateTimeFormat('en-AU', { weekday: 'short'}).format(endDateObj)
  const endDayDate = new Intl.DateTimeFormat('en-AU', { day: 'numeric' }).format(endDateObj)
  const endMonth = new Intl.DateTimeFormat('en-AU', { month: 'short' }).format(endDateObj)

  return `${startDayDate} ${startMonth} - ${endDayDate} ${endMonth}`
}

Vue.prototype.$formatTimeRange = (date, startTime, endTime) => {
  const startDateObj = new Date(date + 'T' + startTime + '+10:00')
  const endDateObj = new Date(date + 'T' + endTime + '+10:00')

  let startTimeHour = new Intl.DateTimeFormat('en-AU', { hour: 'numeric' }).format(startDateObj)
  const startTimeMinute = new Intl.DateTimeFormat('en-AU', { minute: 'numeric' }).format(startDateObj)
  const startTime12 = startDateObj.getHours() >= 12 ? 'PM' : 'AM'

  let endTimeHour = new Intl.DateTimeFormat('en-AU', { hour: 'numeric' }).format(endDateObj)
  const endTimeMinute = new Intl.DateTimeFormat('en-AU', { minute: 'numeric' }).format(endDateObj)
  const endTime12 = endDateObj.getHours() >= 12 ? 'PM' : 'AM'

  if (startTimeMinute !== '00' && startTimeMinute !== '0') {
    startTimeHour = `${startTimeHour.replace(/^0+/g, '').split(' ')[0]}:${startTimeMinute}`
  } else {
    startTimeHour = startTimeHour.replace(/^0+/g, '').split(' ')[0]
  }

  if (endTimeMinute !== '00' && endTimeMinute !== '0') {
    endTimeHour = `${endTimeHour.replace(/^0+/g, '').split(' ')[0]}:${endTimeMinute}`
  } else {
    endTimeHour = endTimeHour.replace(/^0+/g, '').split(' ')[0]
  }

  if (startTime12 === endTime12) {
    return `${startTimeHour.replace(/^0+/g, '').split(' ')[0]} - ${endTimeHour.replace(/^0+/g, '').split(' ')[0]}${endTime12}`
  }

  return `${startTimeHour}${startTime12} - ${endTimeHour}${endTime12}`
}


